(function () {
  'use strict';

  var section = document.querySelector('.support-form');
  if (!section) return;

  var form = section.querySelector('#support-ticket-form');
  var statusEl = section.querySelector('#support-form-status');
  var issueSelect = form.querySelector('[name="issue_type"]');
  var orderField = section.querySelector('#order-number-field');
  var partField = section.querySelector('#part-number-field');
  var apiKey = section.dataset.apiKey || '';

  // Show/hide conditional fields based on issue type
  function toggleConditionalFields() {
    var val = issueSelect.value;
    var showOrder = val === 'return' || val === 'refund' || val === 'order_issue';
    var showPart = val === 'part_request';

    orderField.classList.toggle('support-form__field--hidden', !showOrder);
    partField.classList.toggle('support-form__field--hidden', !showPart);
  }

  issueSelect.addEventListener('change', toggleConditionalFields);
  toggleConditionalFields();

  // Form submission
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var btn = form.querySelector('.support-form__submit');
    var formData = new FormData(form);

    var data = {
      issueType: formData.get('issue_type') || '',
      name: ((formData.get('first_name') || '') + ' ' + (formData.get('last_name') || '')).trim(),
      email: formData.get('email') || '',
      phone: formData.get('phone') || undefined,
      orderNumber: formData.get('order_number') || undefined,
      partNumber: formData.get('part_number') || undefined,
      subject: formData.get('subject') || '',
      description: formData.get('description') || ''
    };

    // Client-side validation
    if (!data.issueType || !data.name || !data.email || !data.subject || !data.description) {
      showStatus('Please fill in all required fields.', 'error');
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Submitting...';
    hideStatus();

    var headers = { 'Content-Type': 'application/json' };
    if (apiKey) headers['x-api-key'] = apiKey;

    fetch('https://www.megaboxcentral.com/api/public/support-ticket', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Server error');
        return res.json();
      })
      .then(function (result) {
        var msg = 'Your support ticket ' + (result.ticketNumber || '') + ' has been submitted. We\'ll get back to you within 1 business day.';
        showStatus(msg, 'success');
        btn.textContent = 'Submitted';
        form.reset();
        toggleConditionalFields();

        if (typeof gtag === 'function') {
          gtag('event', 'support_ticket', {
            issue_type: data.issueType,
            ticket_number: result.ticketNumber
          });
        }
      })
      .catch(function () {
        showStatus('Something went wrong. Please try again or call us at (888) 565-9483.', 'error');
        btn.disabled = false;
        btn.textContent = 'Submit Support Request';
      });
  });

  function showStatus(msg, type) {
    statusEl.textContent = msg;
    statusEl.className = 'support-form__status support-form__status--visible support-form__status--' + type;
  }

  function hideStatus() {
    statusEl.className = 'support-form__status';
  }
})();
